// QR Kiosk v2 — Tier-2 identity pill (initials avatar + name + chevron) → opens
// the AccountSheet. Tier-0/1 mono variants are NOT built now (KV2-8/9).
//
// RECORDED DIVERGENCE KV2-0-a: the designer chip shows the company name, but the
// client account model / JWT carry no tenant-safe company-name string (and the
// machine-profile customerName is the machine OWNER's company — wrong for
// cross-tenant viewers). v2.0 binds the signed-in user's full name instead.
// Revisit at KV2-10 flip review if a tenant-safe company-name source appears.
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import { openAccountSheet } from "../kioskV2Slice";

export function TierChip() {
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.account.user);

  const firstName = user?.firstName || "";
  const lastName = user?.lastName || "";
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  const label = `${firstName} ${lastName}`.trim();

  return (
    <button
      type="button"
      onClick={() => dispatch(openAccountSheet())}
      aria-label={label}
      // L6: the name is ellipsized at 140px; the tooltip carries the full value (desktop/tablet).
      title={label}
      style={{
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: "7px 0",
        margin: "-7px 0",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 7,
          height: 30,
          padding: "0 10px 0 4px",
          borderRadius: 999,
          background: "var(--tier-accent-soft)",
          border: "1px solid var(--tier-accent-line)",
        }}
      >
        <span
          style={{
            width: 22,
            height: 22,
            borderRadius: 999,
            background: "var(--tier-accent)",
            color: "var(--tier-accent-fg)",
            display: "inline-grid",
            placeItems: "center",
            fontSize: 9.5,
            fontWeight: 700,
          }}
        >
          {initials}
        </span>
        <span
          style={{
            fontSize: 12.5,
            fontWeight: 600,
            color: "var(--ink-2)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 140,
          }}
        >
          {label}
        </span>
        <svg viewBox="0 0 12 12" width="9" height="9" fill="none" stroke="var(--muted)" strokeWidth="1.6" strokeLinecap="round">
          <path d="M3 4.5 L6 7.5 L9 4.5" />
        </svg>
      </span>
    </button>
  );
}

export default TierChip;
